import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles

const Description = ({ formData, handleChange }) => {
  return (
    <div>
      <label className="block mb-2 font-semibold text-black text-xl md:text-3xl">
        Description
      </label>
      <ReactQuill
        theme="snow"
        value={formData.description}
        onChange={(content) =>
          handleChange({ target: { name: "description", value: content } })
        }
        className="w-[18.5rem] md:w-full  rounded-2xl mt-2 h-56 mb-20"
      />
    </div>
  );
};

export default Description;
